import { axiosInstance as api } from "../helpers/request";
import { FolderTypeEnum, IFolder } from "../types/models";

const base = (streamId: string) => `/streams/${streamId}/folders`;

class FolderService {
  getFolders(streamId: string, type: FolderTypeEnum) {
    return api.get<IFolder[]>(`${base(streamId)}?type=${type}`);
  }

  getFolderById(streamId: string, id: string) {
    return api.get<IFolder>(`${base(streamId)}/${id}`);
  }

  deleteFolder(streamId: string, id: string) {
    return api.delete<IFolder>(`${base(streamId)}/${id}`);
  }

  createFolder(streamId: string, data: Pick<IFolder, "name" | "type">) {
    return api.post<IFolder>(base(streamId), data);
  }

  updateFolder(streamId: string, data: Pick<IFolder, "id" | "name">) {
    return api.patch(`${base(streamId)}/${data.id}`, data);
  }

  addItemsToFolder(
    streamId: string,
    data: {
      folderId: string | null;
      itemIds: string[];
      type: FolderTypeEnum;
    },
  ) {
    return api.post(`${base(streamId)}/items`, data);
  }
}

const FolderServiceInstance = new FolderService();

export default FolderServiceInstance;
